"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  UPDATE: "@@dataMap/update",
  INFO: "@@dataMap/info",
  FIELD: "@@dataMap/field",
  FIELD_USER: "@@dataMap/fieldUser",
  FIELD_RECORD: "@@dataMap/fieldRecord",
  FIELD_FUND: "@@dataMap/fieldFund",
  FIELD_PERFORMANCE: "@@dataMap/fieldFundPerformance",
  FIELD_DONOR: "@@dataMap/fieldFundDonors",
  FIELD_IMPACT: "@@dataMap/fieldFundImpact",
  RESET: "@@dataMap/reset",
  RESET_UPDATE: "@@dataMap/reset-update",
  RESET_FIELD: "@@dataMap/reset-field",
  SUCCESS: "@@dataMap/success",
  ERROR: "@@dataMap/error"
};
exports.actionTypes = actionTypes;